import RemuneracaoMedicaInterceptor from '@finx/web-repository/src/apis/RemuneracaoMedica/RemuneracaoMedicaInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'
import { IRemuneracaoChatMessage } from '@/types/interfaces/backoffice-remuneracao/remuneracao-chat-message.interface'

const factory = new FactoryResponse()
const api = new RemuneracaoMedicaInterceptor()

export default {
  async enviarMensagem(params: IRemuneracaoChatMessage) {
    const request = await api.post('remuneracao/chat', params)
    return factory.build(request)
  },
}
